<template>
  <div id="app">
    <div id="nav" :class="{ 'nav_bj': $route.meta.issearch }">
      <!-- <div id="fsb_container" class="tip_title" v-show="!$route.meta.navHide">
        <van-image
          height="39"
          fit="contain"
          lazy-load
          src="https://www.xiangzh.com/static/index/default/images/top_1.png"
        />
      </div> -->
      <div style="position: relative;min-height: 44px;">
        <div class="menu_one">
          <div class="menu_list fl" v-if="this.$route.path!='/'" @click="goBack()">
            <!-- <span class="iconfont icon-weibiaoti15"></span> -->
            <van-icon name="arrow-left" size="24" />
          </div>
          <!-- <van-popup class="menu_wrap" v-model="menushow" position="left" closeable
                           :style="{ height: '100%',width: '80%' }">
                    <div class="menu_name" @click="showPopup">
                        <router-link to="/Personal">分类</router-link>
                    </div>
                    <div class="menu">
                        <van-collapse v-model="active1" accordion>
                            <div v-for="(value,index) in nav_header" :key="index">
                                <div v-if="(value.data_type == 'system' && value.name == 'Home')" @click="goHome"><h2>
                                    {{ value.name }}</h2></div>
                                <h2 v-if="!(value.data_type == 'system' && value.name == 'Home')"
                                    @click="toCategory(value.value)">{{ value.name }} </h2>
                                    <div @click="toCategory(value2.value)" v-for="(value2,index2) in value.items"
                                         :key="'2'+index2">
                                        <div class="menu_nr" @click="showPopup">{{ value2.name }}
                                            <van-icon class="nr_icon" name="arrow"/>
                                        </div>
                                    </div>
                            </div>
                        </van-collapse>
                    </div>
                </van-popup> -->
          <!-- <div class="menu_list fl " @click="change">
                    <span class="iconfont icon-sousuo"></span>
                </div> -->
        </div>
        <div class="menu_img">
          <router-link to="/" class="f-clearfix">
            <img
              style="margin-top: 2.2%;width: 50%;"
              fit="contain"
              src="./images/shopLogo.png"
            />
          </router-link>
        </div>
        <router-link to="/Personal">
          <div class="menu_list menu_wode">
            <span class="iconfont icon-wode"></span>
          </div>
        </router-link>
        <!-- <transition name="van-slide-down"> -->

        <!-- </transition> -->
      
      </div>
      <div class="nav_search" v-if="$route.meta.issearch">
            <form action="">
                <van-search v-model="value1" show-action placeholder="请输入商品名称搜索.." background="none">
                    <template #action>
                        <div style="transform: translateY(-3px);">
                            <van-button type="primary" size="small" @click="search" color="#FE7A72">搜索</van-button>
                        </div>
                    </template>
                </van-search>
            </form>
        </div>
    </div>
    <div
      class="fixed-carts"
      id="cart_box"
      @mousedown="down"
      @touchstart="down"
      @mousemove="move"
      @touchmove.prevent="move"
      @mouseup="end"
      @touchend="end"
      ref="cart_box"
      v-show="!$route.meta.navHide"
    >
      <router-link to="/carts">
        <van-icon name="shopping-cart-o" color="#fff" />
        <span class="flex-center" id="cart_total">{{ cart_total }}</span>
      </router-link>
    </div>
    <img  class="kefu" @click="openKefu" src="../src/images/kefu.png" alt="" />
    <!-- <div class="register_box">
      <van-popup v-model="reward">
        <div @click="closeCouponDiv">
          <van-image
            width="100%"
            lazy-load
            src="https://www.xiangzh.com/static/index/default/images/newyouh.gif"
          />
        </div>
        <van-icon
          name="close"
          color="#fff"
          size="25"
          style="margin-top: 10px"
          @click="closeCouponDiv"
        />
      </van-popup>
    </div> -->
    <router-view />
  </div>
</template>

<style scoped>
.register_box .van-popup {
  width: 70%;
  background-color: transparent;
  line-height: 0;
}

.register_box .van-popup a {
  display: block;
}
.tip_title {
  width: 100%;
  text-align: center;
  height: 39px;
  line-height: 39px;
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
  background-color: #fff;
  color: #f73284;
  font-size: 21px;
  font-family: Carter One;
  font-weight: 600;
}
</style>

<script>
export default {
  data() {
    return {
      menushow: false,
      value1: "",
      show1: false,
      active1: "",
      nav_header: [],
      cart_total: 0,
      flags: false,
      position: { x: 0, y: 0 },
      nx: "",
      ny: "",
      dx: "",
      dy: "",
      xPum: "",
      yPum: "",
      reward: false,
    };
  },
  created() {
    this.getNav();
    this.menushow = false;
    var show_coupon_div = window.localStorage.getItem("showCouponDiv");
    var user_info = this.getUserInfo();
    if (show_coupon_div !== "true" && user_info === false) {
      this.reward = true;
    } else {
      this.reward = false;
    }
  },
  methods: {
    goBack() {
        this.$router.back();
    },
    showPopup() {
      this.menushow = !this.menushow;
    },
    hidePopup() {
      this.menushow = false;
    },
    change() {
      this.show1 = !this.show1;
    },
    getNav() {
        console.log("getNav");
      var _self = this;
      this.GET("/nav", function (data) {
        if (data.code == 0) {
          window.nav_header = data.data.header;
          _self.nav_header = data.data.header;
          window.nav_footer = data.data.footer;
          _self.cart_total = data.data.cart_total;
        }
      });
    },
    search() {
      if (this.value1 != "") {
        this.$router.push({
          path: "search",
          query: { keywords: this.value1 },
        });
      } else {
        this.$router.push({ path: "search" });
      }
    },
    // 实现移动端拖拽
    down() {
      this.flags = true;
      var touch;
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      this.position.x = touch.clientX;
      this.position.y = touch.clientY;
      this.dx = this.$refs.cart_box.offsetLeft;
      this.dy = this.$refs.cart_box.offsetTop;
    },
    move() {
      if (this.flags) {
        var touch;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        this.nx = touch.clientX - this.position.x;
        this.ny = touch.clientY - this.position.y;
        this.xPum = this.dx + this.nx;
        this.yPum = this.dy + this.ny;
        this.$refs.cart_box.style.left = this.xPum + "px";
        this.$refs.cart_box.style.top = this.yPum + "px";
        //阻止页面的滑动默认事件；如果碰到滑动问题，1.2 请注意是否获取到 touchmove
        // window.addEventListener("touchmove",function(){
        //     event.preventDefault();
        // },false);
      }
    },
    //鼠标释放时候的函数
    end() {
      this.flags = false;
    },
    toCategory(id) {
      this.menushow = false;
      var _self = this;
      setTimeout(function () {
        _self.$router.push({ path: "/category", query: { id: id } });
      }, 500);
    },
    goHome() {
      this.menushow = false;
      var _self = this;
      setTimeout(function () {
        _self.$router.push("/");
      }, 500);
    },
    toLogin() {
      window.localStorage.setItem("showCouponDiv", true);
      this.reward = false;
      var _self = this;
      setTimeout(function () {
        _self.$router.push("/login");
      }, 500);
    },
    closeCouponDiv() {
      window.localStorage.setItem("showCouponDiv", true);
      this.reward = false;
    },
    openKefu(){
			window.open('https://kf.renguokeji.com/kefu/?app=lishun&amp;extra=eyJpZCI6IjljMjA3Yjk1Y2FhOWUzZWE2NmVlYmIxZjNmNDk0ZjE3IiwidXNlcl9pZCI6IjljMjA3Yjk1Y2FhOWUzZWE2NmVlYmIxZjNmNDk0ZjE3IiwiZGV2aWNlX2lkIjoiOWMyMDdiOTVjYWE5ZTNlYTY2ZWViYjFmM2Y0OTRmMTciLCJwbGF0Zm9ybSI6ImFuZHJvaW');
		},
  },
};
</script>
